import addNumberToHighLevelDB from './add-number-to-highlevel-db'
import checkAvailableNumbers from './check-available-numbers'
import checkTollFreeVerification from './check-tollfree-verification'
import createTollFreeVerification from './create-tollfree-verification'
import resubmitTollFreeVerification from './resubmit-tollfree-verification'
import checkVerification from './check-verification'
import clearTableData from './clear-table-data'
import createNumberPool from './create-number-pool'
import deleteCallerID from './delete-caller-id'
import deleteNumber from './delete-number'
import deletePool from './delete-pool'
import editNumberPool from './edit-number-pool'
import editPhoneNumber from './edit-phone-number'
import editVerifiedCallerId from './edit-verified-caller-id'
import fetchAgencyTwilio from './fetch-agency-twilio'
import fetchCallerIDs from './fetch-caller-ids'
import fetchCampaignStatus from './fetch-campaign-status'
import fetchCountryNumbers from './fetch-country-numbers'
import fetchLocalCallerIDs from './fetch-local-caller-ids'
import fetchLocalNumberPools from './fetch-local-number-pools'
import fetchLocalPhoneNumbers from './fetch-local-phone-numbers'
import fetchLocationTwilio from './fetch-location-twilio'
import fetchNumberPool from './fetch-number-pool'
import fetchPhoneNumbers from './fetch-phone-numbers'
import fetchPhoneNumbersA2PStatus from "./fetch-phone-numbers-a2p-status"
import fetchPhoneNumbersTollFreeStatus from "./fetch-phone-numbers-toll-free-status"
import fetchRegulatoryAddresses from './fetch-regulatory-addresses'
import fetchRegulatoryBundles from './fetch-regulatory-bundle'
import purchaseNumber from './purchase-number'
import purchaseNumberWithStripe from './purchase-number-with-stripe'
import verificationCall from './verification-call'
import setA2PComplianceStatus from './set-a2p-compliance-status'
import linkPhoneNumber from './link-phone-number'

const actions = {
  addNumberToHighLevelDB,
  checkAvailableNumbers,
  checkTollFreeVerification,
  createTollFreeVerification,
  resubmitTollFreeVerification,
  checkVerification,
  clearTableData,
  createNumberPool,
  deleteCallerID,
  deleteNumber,
  deletePool,
  editNumberPool,
  editPhoneNumber,
  editVerifiedCallerId,
  fetchAgencyTwilio,
  fetchCallerIDs,
  fetchCampaignStatus,
  fetchCountryNumbers,
  fetchLocalCallerIDs,
  fetchLocalNumberPools,
  fetchLocalPhoneNumbers,
  fetchLocationTwilio,
  fetchNumberPool,
  fetchPhoneNumbers,
  fetchPhoneNumbersA2PStatus,
  fetchPhoneNumbersTollFreeStatus,
  fetchRegulatoryAddresses,
  fetchRegulatoryBundles,
  purchaseNumber,
  purchaseNumberWithStripe,
  verificationCall,
  setA2PComplianceStatus,
  linkPhoneNumber
}

export default actions
